import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { observer } from 'mobx-react';

interface Props {
	request: DropdownRequest<TaxonomyTagSummary>;
	multi?: boolean;
	allowNewTags?: boolean;
	value: string[] | string;
	mode: ControlMode;
	onChange: (value: TaxonomyTagSummary[] | TaxonomyTagSummary) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class TaxonomyTagsEditorView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const { label, value, multi, allowNewTags, required, mode, request, onChange } = this.props;

		return (
			<DropdownView
				allowNewTags={allowNewTags}
				multi={multi}
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={value}
				required={required}
				disabled={mode === 'display'}
				onChanged={onChange}
				request={request}
				keyField="id"
				textField="displayName"
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/parts/taxonomy-tags-editor.view.tsx